import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule } from '@jsverse/transloco';

export interface SimpleConfirmData {
  headerText?: string
  name: string
  afterNameText?: string
}

@Component({
  selector: 'pixl-confirm-dialog-raw',
  templateUrl: 'confirm-dialog-raw.component.html',
  styleUrl: 'confirm-dialog-raw.component.scss',
  imports: [
    MatButtonModule,
    MatDialogActions,
    MatDialogTitle,
    MatDialogContent,
    TranslocoModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmDialogRawComponent {
  readonly dialogRef = inject(MatDialogRef<ConfirmDialogRawComponent>);
  public readonly data: SimpleConfirmData = inject(MAT_DIALOG_DATA);
  public headerText = signal<string>('');
  public afterNameText = signal<string>('');

  constructor() {
    if (this.data.headerText) {
      this.headerText.set(this.data.headerText);
    }

    if (this.data.afterNameText) {
      this.afterNameText.set(this.data.afterNameText);
    }
  }

  public abort(): void {
    this.dialogRef.close(false);
  }

  public confirm(): void {
    this.dialogRef.close(true);
  }
}
